const data = [
  {
    id: 2,
    videoId: 'LE53qVqe8rM',
  },
  {
    id: 3,
    videoId: 'S9KxnptzZso',
  },
  {
    id: 4,
    videoId: '4JNjMcHsDig',
  },
];

export default data;
